import React from 'react';
import {Provider} from "react-redux";
import {portalStore} from "../redux/store/webStores";
import Portal from './Portal';

class App extends React.Component {
    componentDidMount() {
        setTimeout(() => {
            if (document.getElementsByTagName('iframe')[0]) {
                // 删除iframe
                document.getElementsByTagName('iframe')[0].remove();
            }
        }, 2000);
    }

    render () {
        return (
            <Provider store={portalStore}>
                <Portal/>
            </Provider>
        );
    }
}

export default App;